var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.0001 2.1665C10.1617 2.1665 7.85425 4.474 7.85425 7.31234C7.85425 10.0965 10.0317 12.3498 12.8701 12.4473C12.9567 12.4365 13.0434 12.4365 13.1084 12.4473C13.1301 12.4473 13.1409 12.4473 13.1626 12.4473C13.1734 12.4473 13.1734 12.4473 13.1842 12.4473C15.9576 12.3498 18.1351 10.0965 18.1459 7.31234C18.1459 4.474 15.8384 2.1665 13.0001 2.1665Z",
    fill: "#002C58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5033 15.3291C15.4808 13.3141 10.5516 13.3141 7.50746 15.3291C6.13162 16.25 5.37329 17.4958 5.37329 18.8283C5.37329 20.1608 6.13162 21.3958 7.49662 22.3058C9.01329 23.3241 11.0066 23.8333 13 23.8333C14.9933 23.8333 16.9866 23.3241 18.5033 22.3058C19.8683 21.385 20.6266 20.15 20.6266 18.8066C20.6158 17.4741 19.8683 16.2391 18.5033 15.3291Z",
    fill: "#002C58"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.2765410ba1b8368351d8e64524d4c52a.svg";
export { ForwardRef as ReactComponent };